//window.dataLayer.push({
// 'event': 'consent_status'
// });
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag("consent", "default", {
        ad_storage: "granted",
        analytics_storage: "granted"
    });